module.exports = __webpack_public_path__ + "static/SO_Banner-2d07c281895afa3846fa9b1065a1c96e.jpg";